import _ from "lodash";

export const digits = [
    {label: "Normal", value: 0},
    {label: "2 số", value: -2},
    {label: "3 Số", value: -3},
];

export const filterBalls=Array(10).fill(0);

export     const onMouseEnter = (indexResult,e,activeDigit) => {
    let doc = document.getElementsByClassName(`pop-able-number-${indexResult}`);
    _.forEach(doc, (item) => {
        let num = item.attributes.getNamedItem("data-num").value;
        if (activeDigit < 0) {
            num = num.slice(activeDigit);
        }
        let twoDigit = num.slice(-2);
        let classNames = "highlight hangchuc";
        if (twoDigit.includes(e)) {
            if (twoDigit.charAt(0) === twoDigit.charAt(1)) {
                classNames = "highlight cahaihang";
            } else if (twoDigit.charAt(1) === e.toString()) {
                classNames = "highlight hangdonvi";

            }
            const replaceHtml = `<div>${num.slice(0, -2)}<span class="${classNames}">${twoDigit}</span></div>`;
            item.innerHTML = replaceHtml;
        }
    })


};

export const onMouseLeave = (indexResult,activeDigit) => {
    let doc = document.getElementsByClassName(`pop-able-number-${indexResult}`);
    _.forEach(doc, (item) => {
        let num = item.attributes.getNamedItem("data-num").value;
        if (activeDigit < 0) {
            num = num.slice(activeDigit);
        }
        item.innerHTML = `${num}`;
    })
};

export const onChangeDigits = (indexResult,digit = 0,activeDigit,setActiveDigit) => {
    if (digit === activeDigit) {
        digit = 0;
    }
    setActiveDigit(digit);
    let doc = document.getElementsByClassName(`pop-able-number-${indexResult}`);
    _.forEach(doc, (item) => {
        const num = item.attributes.getNamedItem("data-num").value;
        let number = '';
        if (digit < 0) {
            number = num.slice(digit);
        } else {
            number = num;
        }
        item.innerHTML = `${number}`;
    })
};

export const tinhOption = [
    {label: "Chọn tỉnh", value: 0},
    {label: "An Giang", value: 0},
    {label: "Bình Định", value: 0},
    {label: "Bình Thuận", value: 0},
    {label: "Miền bắc", value: 0},
    {label: "Quảng Bình", value: 0},
    {label: "Quảng Trị", value: 0},
    {label: "Tây Ninh", value: 0},
]


export const bannerGif = [
    ""
]